/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "quote_variant_primary": "font-el-primary after:content-[\"”\"] before:content-[\"”\"]",
  "quote_variant_secondary": "font-el-primary after:content-[\"”\"] before:content-[\"”\"]",
  "quote_size_default": "sm:text-el-quote-sm md:text-el-quote-lg",
  "quote_colors_default": "",
  "quotationMark_variant_primary": "hidden",
  "quotationMark_variant_secondary": "hidden",
  "quotationMark_size_default": "mb-4",
  "quotationMark_colors_default": "",
  "author_variant_primary": "block normal-case font-el-secondary",
  "author_variant_secondary": "block normal-case font-el-secondary",
  "author_size_default": "text-el-preview-sm md:text-el-gabor-md mt-3",
  "author_colors_default": "",
  "variant_primary": "text-center font-el-primary not-italic uppercase",
  "variant_secondary": "flex items-start text-left font-el-primary not-italic uppercase",
  "size_default": "w-full p-6 text-el-quote-sm sm:text-el-quote-lg",
  "colors_default": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ContentQuotebox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;